<!--
  TB-071: short notice on the login pages when the browser blocks site data.
  Signing in keeps the session in localStorage, so without it login cannot
  stick. Shown only on the patient and doctor login routes.
-->
<template>
  <!-- live region always present so screen readers announce the text when it appears -->
  <div role="status">
    <div
      v-if="visible"
      class="tb-storage-notice"
      data-test="storage-blocked-notice"
    >
      Please allow site data (cookies and storage) for this site to sign in.
    </div>
  </div>
</template>

<script>
import { storageAvailable } from '@/utils/safeStorage'

export const LOGIN_ROUTES = ['login', 'doctor-login']

export default {
  name: 'StorageBlockedNotice',
  computed: {
    // storageAvailable() is probed once per page load; it cannot change in a tab
    visible () {
      const name = this.$route && this.$route.name
      return LOGIN_ROUTES.includes(name) && !storageAvailable()
    }
  }
}
</script>

<style scoped>
.tb-storage-notice {
  /* bottom of the viewport: the auth top bar is fixed at the top */
  position: fixed;
  left: 50%;
  bottom: max(16px, env(safe-area-inset-bottom));
  transform: translateX(-50%);
  z-index: 60000;
  width: max-content;
  max-width: calc(100% - 32px);
  padding: 10px 16px;
  border: 1px solid var(--tb-warning-text, #9a5800);
  border-radius: var(--tb-radius-control, 8px);
  background: var(--tb-warning-bg, #fff4e5);
  color: var(--tb-warning-text, #9a5800);
  box-shadow: var(--tb-shadow-md, 0 2px 8px rgba(0, 0, 0, 0.12));
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  pointer-events: none;
}
</style>
